import { ButtonPrimary } from 'components/molecules/Button';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { isHermandar } from 'utils/contants';

const GoActivityButton = ({ activity, btnCard = false }) => {
  const { t } = useTranslation();

  const activityFrom = activity?.activity_from;
  const activityDate = activityFrom ? new Date(activityFrom) : null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  return (
    <Link to={`/detail/${activity?.id}`} className="button-reactour" style={btnCard ? { width: '100%' } : {}}>
      <ButtonPrimary style={btnCard ? { borderRadius: '10px', width: '100%', padding: '5px', fontWeight: 500 } : {}}>
        {isHermandar && activityDate && activityDate > today
          ? t('button.button_msg22')
          : isHermandar && (activityDate === null || activityDate <= today)
          ? t('button.button_msg21')
          : t('button.go_activity')}
      </ButtonPrimary>
    </Link>
  );
};

export default GoActivityButton;
